declare global {
  interface Window {
    appInsights?: {
      trackEvent(event: { name: string; properties?: Record<string, string> }): void;
    };
  }
}

export function trackLogoutTrigger(
  trigger: string,
  details?: Record<string, string>
) {
  const info = JSON.parse(sessionStorage.getItem('UserInformation') || '{}');
  const payload: Record<string, string> = {
    trigger,
    userName: info.userName || 'unknown',
    userId: info.userId || 'unknown',
    url: window.location.href,
    timestamp: new Date().toISOString(),
    ...details,
  };

  console.error('[LOGOUT DIAGNOSTIC]', payload);

  try {
    window.appInsights?.trackEvent({
      name: 'ForcedLogout',
      properties: payload,
    });
  } catch {
    // App Insights SDK may not be fully initialized
  }
}
